import { SubscriptionAPIService } from "./subscription";
import api from "..";

export default new SubscriptionAPIService(api);
